var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.884 374.855c-1.123-5.279 1.453-10.63 6.269-13.065 42.616-21.537 70.802-58.877 70.802-101.337 0-52.852-43.671-97.763-104.486-114.145-77.876 3.604-139.604 53.835-139.604 115.282 0 63.787 66.516 115.497 148.567 115.497.201 0 .403 0 .604-.001 4.047-.013 7.807 2.107 9.83 5.612 1.771 3.069 3.538 5.628 5.714 8.291l5.329-5.003c-1.347-4.484-2.478-8.558-3.025-11.131z",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.299 358.489c40.75-20.594 67.701-56.298 67.701-96.899 0-63.787-66.516-115.497-148.567-115.497-11.145 0-21.999.961-32.443 2.77 66.447 11.507 116.125 57.604 116.125 112.727 0 40.601-26.951 76.305-67.701 96.899-4.606 2.328-7.069 7.445-5.995 12.493 1.48 6.958 3.672 13.72 6.162 20.007 21.446 26.551 60.871 33.811 77.229 35.718 2.931.342 4.943-2.863 3.349-5.346-6.079-9.47-17.311-29.018-21.855-50.38-1.074-5.047 1.389-10.164 5.995-12.492z",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.739 87.366c-92.448 11.95-162.739 74.377-162.739 149.637 0 35.731 15.889 68.577 42.471 94.502 3.125 3.048 4.325 7.58 3.176 11.792-8.259 30.296-26.136 57.677-36.904 72.3 3.575 3.575 8.896 4.778 13.657 3.077 27.019-9.651 39.25-19.991 59.318-41.356 5.141-5.473 13.201-7.013 20.025-3.881 4.556 2.091 9.233 4.038 14.018 5.838 5.848 2.2 12.135 3.26 18.35 2.617 1.341-.139 2.715-.056 4.068.265 8.163 1.936 16.05 3.379 24.629 4.474l37.157-1.2c78.272-21.641 134.317-79.728 134.317-148.003 0-70.404-59.593-129.977-141.701-149.923z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#78c2a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.972 371.563c-21.929 23.347-34.5 33.53-67.229 44.033-1.416 1.922-2.714 3.634-3.845 5.092-1.938 2.497-.107 6.121 3.053 6.042 21.599-.539 82.192-5.374 118.88-41.445 2.987-2.937 7.273-4.097 11.349-3.13-.009-.017-.02-.034-.029-.051-14.895-3.524-29.033-8.395-42.183-14.431-6.814-3.126-14.863-1.575-19.996 3.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.181 85.267c-11.055 0-21.89.726-32.442 2.098 92.352 12.013 162.738 74.43 162.738 149.637 0 75.188-70.351 137.592-162.668 149.628 10.532 1.369 21.339 2.108 32.372 2.108 107.796 0 195.181-67.934 195.181-151.735s-87.385-151.736-195.181-151.736z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#f0f7ff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.954,
    cy: 236.145,
    r: 19.051
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.345,
    cy: 236.145,
    r: 19.051
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.736,
    cy: 236.145,
    r: 19.051
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.126,
    cy: 236.145,
    r: 19.051
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c3cafec657986212a435ade105f4bf96.svg";
export { ForwardRef as ReactComponent };